import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h5 className='mt-3 text-success'>Difference between javascript and nodejs</h5>
            <div className="row">

                <div className="col-md-6">
                    <h3>Javascript</h3>
                    <li>Javascript is a programming language that is used for writing scripts on the website. </li>
                    <li>Javascript can only be run in the browsers. </li>
                    <li>It is basically used on the client-side. </li>
                    <li>Javascript is capable enough to add HTML and play with the DOM</li>

                </div>

                <div className="col-md-6">
                    <h3>NodeJS</h3>
                    <li>NodeJS is a Javascript runtime environment. </li>
                    <li>We can run Javascript outside the browser with the help of NodeJS.</li>
                    <li>It is mostly used on the server-side.</li>
                    <li>V8 is the Javascript engine inside of node.js that parses and runs Javascript. </li>
                </div>
            </div>

            <div className="row">

                <div className="col-md-12">
                    <h5 className='mt-5 text-success'>When should you use nodejs and when should you use mongodb</h5>

                    <p style={{ textAlign: 'justify', padding: '20px' }}>Nodejs is a Javascript engine that you can write any application you want with (by programming in the Javascript language). It runs your Javascript code. Most commonly, it is used to build servers that can respond to web requests, though it can be used for lots of other types of code too.

                        MongoDB is a database engine. Code within some application or server uses MongoDB to save, query or update data in a database. There are many web servers built with nodejs that will then use MongoDB for storing data.

                        MongoDB offers an API library that runs within a Nodejs application to give you programmatic access to MongoDB so you can create databases and then add, query, update or delete data from the MongoDB database. MongoDB also has API libraries for other programming environments such as Python, Java, etc...

                        These two technologies are for different parts of a typical web server system. You don't substitute one for the other. Instead, you can use them together.</p>

                </div>


            </div>


            <h5 className='text-success'>Differences between sql and nosql databases.</h5>
            <div className="row mb-5">
                <div className="col-md-6">
                    <h6 className='text-info'>SQL</h6>
                    <li>RELATIONAL DATABASE MANAGEMENT SYSTEM (RDBMS)</li>
                    <li>These databases have fixed or static or predefined schema</li>
                    <li>These databases are not suited for hierarchical data storage.</li>
                    <li>These databases are best suited for complex queries</li>
                    <li>Vertically Scalable</li>

                </div>
                <div className="col-md-6">
                    <h6 className='text-info'>NoSQL</h6>
                    <li>Non-relational or distributed database system.</li>
                    <li>They have dynamic schema</li>
                    <li>These databases are best suited for hierarchical data storage.</li>
                    <li>These databases are not so good for complex queries</li>
                    <li>Horizontally scalable</li>

                </div>
            </div>
        </div>
    );
};

export default Blogs;